import { heroStats } from '@/pages/home/mocks/data';

export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative pt-[72px] min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20stage%20background%20with%20warm%20crimson%20and%20amber%20spotlights%20crossing%2C%20abstract%20curtain%20texture%2C%20theatrical%20atmosphere%2C%20no%20people%2C%20cinematic%20lighting%2C%20mysterious%20and%20dramatic%20vibe%2C%20dark%20red%20and%20black%20gradient%2C%20elegant%20shadows&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="51吃瓜黑料网背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left w-full">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-5">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-sm text-primary-200 font-medium whitespace-nowrap">全网最热八卦 · 实时追踪</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
              51吃瓜黑料网
              <span className="block text-xl md:text-2xl lg:text-3xl font-normal text-white/80 mt-2">
                全网最全娱乐八卦黑料聚合平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-white/70 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              51吃瓜黑料网汇聚娱乐圈最新最劲爆的八卦资讯，涵盖明星恋情、综艺内幕、影视黑料、网红翻车等多维度内容。
              7×24小时不间断更新，支持安卓版、iOS版与轻量版多端浏览，让你随时随地吃到新鲜热乎的瓜。
              当前站内已收录超过3万条八卦资讯，每日新增200+条内容，覆盖12大娱乐领域。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-400">{stat.value}</div>
                  <div className="text-xs md:text-sm text-white/50">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                onClick={(e) => handleScroll(e, 'app')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-all text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line"></i>
                立即下载APP
              </a>
              <a
                href="#index"
                onClick={(e) => handleScroll(e, 'index')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg transition-all border border-white/20 text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                浏览专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 flex justify-center lg:justify-end w-full">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <img
                src="https://readdy.ai/api/search-image?query=A%20floating%20smartphone%20displaying%20a%20dark%20theme%20gossip%20news%20feed%20with%20red%20hot%20labels%2C%20surrounded%20by%20floating%20watermelon%20slices%20and%20newspaper%20fragments%2C%20dramatic%20lighting%2C%20modern%20UI%20design%2C%20warm%20crimson%20accents%2C%20clean%20dark%20background%2C%20editorial%20tech%20product%20photography&width=800&height=700&seq=hero-visual-main&orientation=portrait"
                alt="51吃瓜APP展示"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}